/**
 * 会員説明書（PDF）の配信先
 *
 * 目的: フッターとマイページの2か所から同じPDFを指すため、パスと表示名を1か所に置く。
 *
 * public/ に直接置いている理由:
 * - メディアライブラリ（S3/CloudFront）にアップするとファイル名にハッシュが付き、
 *   説明書を改訂して上げ直すたびにURLが変わってリンクが切れる。
 *   public/ なら同名で上書きしてデプロイするだけで差し替わる
 * - ファイル名を英数字にしているのは、日本語ファイル名がURLエンコードされ、
 *   メールやLINEに貼ったときに崩れて見えるため
 */

/** 会員説明書PDFのURL（public/documents 配下） */
export const MEMBER_GUIDE_PDF_PATH = '/documents/yuikai-member-guide.pdf';

/** リンクに出す表示名 */
export const MEMBER_GUIDE_LABEL = '会員説明書';
